(() => {
'use strict';

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const $ = (selector, scope = document) => scope.querySelector(selector);
const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const routes = window.TailMotiveRoutes || { root: '/', cart: '/cart', add: '/cart/add', change: '/cart/change' };
let lastCartTrigger;
let lastMenuTrigger;

function setLocked(locked) {
  document.body.classList.toggle('is-locked', locked);
}

function setBackgroundInert(mode = null) {
  const main = document.querySelector('main');
  const footer = $('.site-footer');
  const header = $('.site-header');
  if (main) main.inert = Boolean(mode);
  if (footer) footer.inert = Boolean(mode);
  if (header) header.inert = mode === 'cart';
}

function getFocusable(container) {
  return $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
    .filter((element) => !element.hidden && element.getClientRects().length);
}

function trapFocus(event, container) {
  const focusable = getFocusable(container);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

function openCart(trigger) {
  closeMenu(false);
  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  lastCartTrigger = trigger || document.activeElement;
  drawer.hidden = false;
  overlay.hidden = false;
  setBackgroundInert('cart');
  setLocked(true);
  $$('[data-cart-open]').forEach((element) => element.setAttribute('aria-expanded', 'true'));
  $('[data-cart-close]', drawer)?.focus();
}

function closeCart(restoreFocus = true) {
  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-cart-overlay]');
  if (!drawer || drawer.hidden) return;
  drawer.hidden = true;
  if (overlay) overlay.hidden = true;
  setBackgroundInert();
  setLocked(false);
  $$('[data-cart-open]').forEach((element) => element.setAttribute('aria-expanded', 'false'));
  if (restoreFocus) lastCartTrigger?.focus();
}

function openMenu(trigger) {
  closeCart(false);
  const menu = $('[data-mobile-menu]');
  if (!menu) return;
  lastMenuTrigger = trigger || document.activeElement;
  menu.hidden = false;
  trigger?.setAttribute('aria-expanded', 'true');
  setBackgroundInert('menu');
  setLocked(true);
  $('[data-menu-close]', menu)?.focus();
}

function closeMenu(restoreFocus = true) {
  const menu = $('[data-mobile-menu]');
  if (!menu || menu.hidden) return;
  menu.hidden = true;
  $('[data-menu-open]')?.setAttribute('aria-expanded', 'false');
  setBackgroundInert();
  setLocked(false);
  if (restoreFocus) lastMenuTrigger?.focus();
}

async function refreshCart(shouldOpen = false) {
  const restoreTrigger = $('[data-cart-open]') || document.activeElement;
  const [sectionResponse, cartResponse] = await Promise.all([
    fetch(`${routes.root}?section_id=cart-drawer`, { credentials: 'same-origin' }),
    fetch(`${routes.cart}.js`, { credentials: 'same-origin' })
  ]);
  if (!sectionResponse.ok || !cartResponse.ok) throw new Error('The cart could not be refreshed. Please try again.');
  const html = await sectionResponse.text();
  const cart = await cartResponse.json();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const next = $('[data-cart-drawer-content]', parsed);
  const current = $('[data-cart-drawer-content]');
  if (next && current) current.innerHTML = next.innerHTML;
  $$('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
  if (shouldOpen) openCart(restoreTrigger);
}

document.addEventListener('click', async (event) => {
  const cartTrigger = event.target.closest('[data-cart-open]');
  if (cartTrigger) openCart(cartTrigger);
  if (event.target.closest('[data-cart-close]') || event.target.matches('[data-cart-overlay]')) closeCart();

  const menuTrigger = event.target.closest('[data-menu-open]');
  if (menuTrigger) openMenu(menuTrigger);
  if (event.target.closest('[data-menu-close]')) closeMenu();

  const quickAdd = event.target.closest('[data-cart-quick-add]');
  if (quickAdd) {
    event.preventDefault();
    const originalLabel = quickAdd.textContent;
    const status = $('[data-cart-upsell-status]');
    quickAdd.disabled = true;
    quickAdd.textContent = 'Adding…';
    if (status) status.textContent = '';
    try {
      const response = await fetch(`${routes.add}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(quickAdd.dataset.variantId), quantity: 1 }] })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || 'Unable to add this item.');
      if (quickAdd.closest('[data-main-cart]')) {
        window.location.reload();
        return;
      }
      await refreshCart(true);
    } catch (error) {
      quickAdd.disabled = false;
      quickAdd.textContent = originalLabel;
      if (status) status.textContent = error.message;
    }
  }

  const lineChange = event.target.closest('[data-cart-line-change]');
  if (lineChange) {
    event.preventDefault();
    const status = $('[data-cart-status]');
    lineChange.disabled = true;
    if (status) status.textContent = 'Updating your cart…';
    try {
      const response = await fetch(`${routes.change}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineChange.dataset.lineKey, quantity: Number(lineChange.dataset.quantity) })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || 'Unable to update your cart.');
      if (lineChange.closest('[data-main-cart]')) {
        window.location.reload();
        return;
      }
      await refreshCart(true);
    } catch (error) {
      lineChange.disabled = false;
      if (status) status.textContent = error.message;
    }
  }

});

document.addEventListener('keydown', (event) => {
  const drawer = $('[data-cart-drawer]');
  const menu = $('[data-mobile-menu]');
  if (event.key === 'Escape') {
    if (drawer && !drawer.hidden) closeCart();
    else if (menu && !menu.hidden) closeMenu();
  }
  if (event.key === 'Tab' && drawer && !drawer.hidden) trapFocus(event, drawer);
  else if (event.key === 'Tab' && menu && !menu.hidden) trapFocus(event, menu);
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.submitting === 'true') return;
  form.dataset.submitting = 'true';

  const button = $('[data-add-to-cart]', form);
  if (!button) {
    form.dataset.submitting = 'false';
    return;
  }
  const stickyButton = $$('[data-sticky-submit]').find((item) => item.getAttribute('form') === form.id);
  const label = $('span', button);
  const errorMessage = $('[data-product-error]', form);
  const originalLabel = label?.textContent;
  const originalStickyLabel = stickyButton?.textContent;

  if (errorMessage) {
    errorMessage.hidden = true;
    errorMessage.textContent = '';
  }
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (stickyButton) {
    stickyButton.disabled = true;
    stickyButton.setAttribute('aria-busy', 'true');
    stickyButton.textContent = 'Adding…';
  }
  if (label) label.textContent = 'Adding…';

  let itemAdded = false;
  try {
    const response = await fetch(`${routes.add}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || 'Unable to add this item.');
    itemAdded = true;
    if (label) label.textContent = 'Added to your road kit';
    try {
      await refreshCart(true);
    } catch (refreshError) {
      window.location.assign(routes.cart);
      return;
    }
  } catch (error) {
    if (errorMessage) {
      errorMessage.textContent = itemAdded
        ? 'Item added. Opening your cart…'
        : error.message;
      errorMessage.hidden = false;
    }
  } finally {
    button.removeAttribute('aria-busy');
    stickyButton?.removeAttribute('aria-busy');
    window.setTimeout(() => {
      form.dataset.submitting = 'false';
      button.disabled = button.dataset.variantAvailable !== 'true';
      if (label && originalLabel) label.textContent = originalLabel;
      if (stickyButton) {
        stickyButton.disabled = button.dataset.variantAvailable !== 'true';
        if (originalStickyLabel) stickyButton.textContent = originalStickyLabel;
      }
    }, 900);
  }
});

function formatMoney(cents) {
  if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
  return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
    style: 'currency',
    currency: window.TailMotiveCurrency || 'USD'
  });
}

function initializeProductSection(section) {
  if (section.dataset.variantInitialized === 'true') return;
  const json = $('[data-product-json]', section.parentElement) || $('[data-product-json]');
  if (!json) return;
  const variants = JSON.parse(json.textContent);
  const form = $('[data-product-form]', section);
  if (!form) return;
  section.dataset.variantInitialized = 'true';

  const optionInputs = $$('[data-option-position]', section);

  function updateVariant() {
    const variantInput = $('[data-variant-id]', form);
    variantInput.name = 'id';
    const selected = [];
    optionInputs.filter((element) => element.checked).forEach((element) => {
      selected[Number(element.dataset.optionPosition) - 1] = element.value;
    });

    optionInputs.forEach((input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      const canSelect = variants.some((item) => item.available
        && item.options[position] === input.value
        && item.options.slice(0, position).every((value, index) => value === selected[index]));
      input.disabled = !input.checked && !canSelect;
      input.setAttribute('aria-disabled', String(!canSelect));
    });

    const variant = optionInputs.length
      ? variants.find((item) => item.options.every((value, index) => value === selected[index]))
      : variants.find((item) => String(item.id) === variantInput.value)
        || variants.find((item) => item.available)
        || variants[0];
    const submit = $('[data-add-to-cart]', form);
    const stickyButton = $('[data-sticky-submit]', section.parentElement);
    const stickyPrice = $('[data-sticky-price]', section.parentElement);
    const currentPrice = $('[data-product-price-current]', section);
    const comparePrice = $('[data-product-price-compare]', section);
    const comparePriceWrap = $('[data-product-price-compare-wrap]', section);
    const priceWrapper = $('[data-price-wrapper]', section);
    const status = $('[data-variant-status]', section);

    if (!variant) {
      variantInput.value = '';
      submit.disabled = true;
      submit.dataset.variantAvailable = 'false';
      $('span', submit).textContent = 'Unavailable combination';
      if (stickyButton) {
        stickyButton.disabled = true;
        stickyButton.textContent = 'Unavailable';
      }
      if (status) status.textContent = 'This option combination is unavailable.';
      return;
    }

    variantInput.value = variant.id;
    const price = formatMoney(variant.price);
    const hasComparePrice = Number(variant.compare_at_price) > Number(variant.price);
    submit.disabled = !variant.available;
    submit.dataset.variantAvailable = String(variant.available);
    $('span', submit).textContent = variant.available ? `${submit.dataset.addLabel || 'Add to cart'} — ${price}` : 'Sold out';
    if (currentPrice) currentPrice.textContent = price;
    if (comparePrice) {
      comparePrice.textContent = hasComparePrice ? formatMoney(variant.compare_at_price) : '';
    }
    if (comparePriceWrap) comparePriceWrap.hidden = !hasComparePrice;
    if (priceWrapper) priceWrapper.classList.toggle('tm-price--sale', hasComparePrice);
    if (stickyButton) {
      stickyButton.disabled = !variant.available;
      stickyButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    if (stickyPrice) stickyPrice.textContent = price;
    if (status) status.textContent = variant.available
      ? `${variant.options.join(', ')} selected. ${price}. In stock.`
      : `${variant.options.join(', ')} selected. Sold out.`;

    if (variant.featured_media_id) {
      const media = $$('[data-media-id]', section).find((element) => element.dataset.mediaId === String(variant.featured_media_id));
      if (media) {
        $$('[data-media-id]', section).forEach((element) => element.classList.toggle('is-active', element === media));
        if (window.matchMedia('(max-width: 749px)').matches) {
          $('[data-gallery]', section)?.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
        }
      }
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
  }

  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  updateVariant();

  const sticky = $('[data-sticky-atc]', section.parentElement);
  const mainSubmit = $('[data-add-to-cart]', form);
  if (sticky && mainSubmit) {
    sticky.setAttribute('aria-hidden', 'true');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      });
      observer.observe(mainSubmit);
    } else {
      sticky.classList.add('is-visible');
      sticky.removeAttribute('aria-hidden');
    }
  }
}

function initializeProductSections(scope = document) {
  if (scope.matches?.('[data-product-section]')) initializeProductSection(scope);
  $$('[data-product-section]', scope).forEach(initializeProductSection);
}

initializeProductSections();
document.addEventListener('shopify:section:load', (event) => initializeProductSections(event.target));
})();
